export default "__VITE_ASSET__DmK1dvtQ__"